/**
 * Resolves a localized string key against a campaign's `localized_strings`
 * map. Mirrors `resolve_localized_string` in
 * `trivelta-backend-services/.../catalog/results/base.py`: try `locale`,
 * then fall back to `"en"`, then fall back to the raw key itself.
 */
export const resolveLocalizedString = (
  key: string | undefined,
  localizedStrings: Record<string, Record<string, string>> | undefined,
  locale: string = "en",
): string => {
  if (!key) return "";
  const candidates = locale !== "en" ? [locale, "en"] : ["en"];
  for (const candidate of candidates) {
    const value = localizedStrings?.[candidate]?.[key];
    if (value) return value;
  }
  return key;
};
